<div class="container-fluid" *ngIf="isAuthenticated">
  <div class="user-details d-none">{{ username }}</div>
  <app-confetti></app-confetti>
  <div class="row">
    <div class="col-auto replace-padding" *ngIf="showMenu">
      <app-side-menu></app-side-menu>
    </div>
    <div class="col replace-padding main-container">
      <app-title-bar *ngIf="showMenu"></app-title-bar>
      <div class="content" [ngClass]="showMenu ? 'content-with-title' : ''">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
